export default __webpack_public_path__ + "static/media/deletenew-icon1.8e8f9383.svg";